// extracted by mini-css-extract-plugin
export var container = "_gb-1";
export var cornerButtonContainer = "_gb-6";
export var disabled = "_gb-2";
export var dragActive = "_gb-3";
export var fileContainer = "_gb-5";
export var hiddenInput = "_gb-4";
export var widthContainer = "_gb-0";